import React from 'react';

import {isFunction} from 'lodash-es';
import PropTypes from 'prop-types';

import Modal from 'components/ModalV2/ModalV2';
import SignInContainer from 'static/three-oh/src/routes/SignIn/containers/SignInContainer';

import styles from './styles.scss';

const CLOSED_STATE = {
  errorMessage: null,
  isOpen: false,
  password: '',
  username: '',
  showMoreAuthOptions: false,
};

const propTypes = {
  theme: PropTypes.oneOf(['spring', 'fall', 'winter']),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

const defaultProps = {
  theme: 'spring',
  isOpen: false,
};

class SignInModal extends React.PureComponent {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.isOpen) {
      return {
        ...prevState,
        isOpen: true,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = {...CLOSED_STATE};
  }

  componentDidMount() {
    // The modal is closed by default until an 'openSignInModal' window event is broadcast.
    window.addEventListener('openSignInModal', this.onOpenModal);
  }

  componentWillUnmount() {
    window.removeEventListener('openSignInModal', this.onOpenModal);
  }

  onOpenModal = () => {
    this.setState({isOpen: true});
  };

  onCloseModal = () => {
    if (isFunction(this.props.onClose)) {
      this.props.onClose();
    }
    this.setState(CLOSED_STATE);
  };

  render() {
    const {isOpen} = this.state;
    const {theme} = this.props;

    const modalProps = {
      inModal: true,
      onCloseModal: this.onCloseModal,
    };
    return (
      <Modal
        open={isOpen}
        onClose={this.onCloseModal}
        classNames={styles.modal}
        transition="popIn"
        additionalOverlayClass={styles.overlay}
      >
        <div
          className={styles[theme]}
          role="dialog"
          aria-label="Sign in to Newsela with"
          data-qa-selector="sign_in_modal"
        >
          <SignInContainer {...modalProps}/>
        </div>
      </Modal>
    );
  }
}

SignInModal.propTypes = propTypes;
SignInModal.defaultProps = defaultProps;

export default SignInModal;
